import { useEffect } from 'react';
import { useStateMethods } from '../providers/state';
import { useEvents } from '../providers/events';
import { isImage } from '../../../helpers/attachments/isImage';
import { stateKeys } from '../constants/stateKeys';

export const useSetImages = (attachments) => {
  const { getExtension } = useEvents();

  const { setState } = useStateMethods();

  useEffect(() => {
    const { images, indexes } = attachments.reduce(
      (result, attachment) => {
        const extension = getExtension(attachment);

        if (isImage(extension)) {
          result.indexes.set(attachment.id, result.images.length);
          result.images.push(attachment);
        }

        return result;
      },
      { images: [], indexes: new Map() }
    );

    setState((prev) => {
      const prevImages = prev[stateKeys.images];

      return !prevImages.length && !images.length
        ? undefined
        : { [stateKeys.imageIndexes]: indexes, [stateKeys.images]: images };
    });
  }, [attachments, getExtension, setState]);
};
